import { z } from "zod";

const schema = z.object({
  VITE_APP_NAME: z.string().default("Cruzeiro Life"),
  VITE_USE_MOCKS: z.enum(["true", "false"]).default("true"),
  // A relative path is required when the pilot is served behind the same
  // reverse proxy as the mock API. Keep absolute URLs available for local
  // development, but reject protocol-relative and malformed values.
  VITE_API_URL: z
    .string()
    .refine(
      (value) => {
        if (value.startsWith("/")) return !value.startsWith("//");
        try {
          new URL(value);
          return true;
        } catch {
          return false;
        }
      },
      { message: "VITE_API_URL must be an absolute URL or a safe relative path." },
    )
    .default("http://localhost:8787"),
  VITE_SUPABASE_URL: z.string().default("http://127.0.0.1:54321"),
  VITE_SUPABASE_ANON_KEY: z.string().default("local-anon-key"),
});

const parsed = schema.parse(import.meta.env);

export const env = {
  appName: parsed.VITE_APP_NAME,
  useMocks: parsed.VITE_USE_MOCKS === "true",
  apiUrl: parsed.VITE_API_URL,
  supabaseUrl: parsed.VITE_SUPABASE_URL,
  supabaseAnonKey: parsed.VITE_SUPABASE_ANON_KEY,
};
